export default __webpack_public_path__ + "static/media/Vcura-no-background.fa422a50.png";